"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormDescripcion({
  inputValues,
  onChange
}) {
  const theme = (0, _styles.useTheme)();
  const classes = (0, _style.default)(theme);
  const textAreaText = [{
    state: 'descripcion_ubicacion',
    label: 'Ubicación y Entorno',
    helpText: '¿Como es el entorno?¿Que hay cerca?¿Que tiene de bueno la ubicación?'
  }, {
    state: 'descripcion_diferencia',
    label: 'Diferenciales del Alojamiento',
    helpText: '¿Que comodidades ofrece tu alojamiento?¿Por que es una excelente opción?'
  }, {
    state: 'descripcion_servicios',
    label: 'Servicios y Atención',
    helpText: '¿Como lo esperas?¿Que ofreces?¿Quien eres?'
  }, {
    state: 'descripcion_normas',
    label: 'Normas y Restricciones',
    helpText: '¿Cuales son las normas?¿Que no esta permitido?¿Como te vas a relacionar?'
  }];
  return (0, _react2.jsx)("div", {
    css: classes.root
  }, textAreaText.map(text => (0, _react2.jsx)(_material.TextField, {
    variant: "standard",
    key: text.state,
    id: text.state,
    style: {
      marginBottom: 8,
      width: '100%'
    },
    label: text.label,
    multiline: true,
    maxRows: "5",
    helperText: text.helpText,
    defaultValue: inputValues[text.state],
    onBlur: e => onChange(text.state, e.target.value)
  })));
}

var _default = FormDescripcion;
exports.default = _default;